export default __webpack_public_path__ + "static/media/Kalemaam.738b78a7.jpg";